export default function initAccordionAnchors() {


  // Bail if this JS is loaded outside of WordPress
  if (CC_CONSTANTS.isNonWp) {
      console.cclog('[Accordion Anchor Debug] loaded outside of WP, skipping...');
      return;
  }


  const anchor = window.location.hash;
  
  if (anchor) {
      const accordionItem = document.querySelector(anchor);
      
      if (accordionItem) {
          // Calculate the position to scroll to (with an offset of 150px).
          const positionToScrollTo = accordionItem.getBoundingClientRect().top + window.scrollY - 150;
          
          // Scroll to the accordion item.
          window.scrollTo({
              top: positionToScrollTo,
              behavior: 'smooth'
          });

          setTimeout(function() {
              const button = accordionItem.querySelector('.accordion-layer-btn');
              if (button) {
                  button.click();
              }
          }, 500);
      }
  }
}
